export default __webpack_public_path__ + "static/media/folder_2.bc530032.svg";